import { memo, useMemo } from "react";
import { number } from "prop-types";
import { TimelineValueCell, useEstimateTableSettings } from "@tools";

export const TimelineFiller = memo(({
  totalDevelopmentTime,
}) => {
  const { timelineLength } = useEstimateTableSettings();
  
  const fillerMonths = useMemo(() => (
    Math.max(timelineLength - totalDevelopmentTime, 0)
  ), [timelineLength, totalDevelopmentTime]);
  
  return (
    <>
      {
        [...new Array(fillerMonths).keys()]
          .map((_, i) => (
            <TimelineValueCell
              key={`month${i}`}
              monthIndex={totalDevelopmentTime + i}
              // visible={!turnOff}
            />
          ))
      }
    </>
  )
})

TimelineFiller.propTypes = {
  totalDevelopmentTime: number,
}